(function() {
    if (window.__FSAHasFired) {
      return;
    }

    window.Branch = window.Branch || {};
    window.Branch.fsa = window.Branch.fsa || {};
    window.Branch.fsa.modals = window.Branch.fsa.modals || {};
    window.Branch.fsa.modals.pdp = window.Branch.fsa.modals.pdp || {};
    window.Branch.fsa.modals['side-cart'] = window.Branch.fsa.modals['side-cart'] || {};
    window.Branch.fsa.modals.bundle = window.Branch.fsa.modals.bundle || {};


    window.__FSAHasFired = true;

    window.Branch.fsa.initFSAListeners = function(bannerType, fsaModal){
    if(fsaModal.getAttribute('data-initialized') != 'true'){
        fsaModal.setAttribute('data-initialized', true);
        if(bannerType == 'pdp'){
            window.Branch.fsa.modals[`${bannerType}`].modalsmobileModal = document.querySelector('.main-product__mobile-tablet-title-review-price-container #fsa-hsa-modal');
            window.Branch.fsa.modals[`${bannerType}`].desktopModal = document.querySelector('.main-product__title-review-price-container #fsa-hsa-modal');
            window.Branch.fsa.modals[`${bannerType}`].mobileBtn = document.querySelector('.main-product__mobile-tablet-title-review-price-container #fsa-hsa-cta');
            window.Branch.fsa.modals[`${bannerType}`].desktopBtn = document.querySelector('.main-product__title-review-price-container #fsa-hsa-cta');
            window.Branch.fsa.modals[`${bannerType}`].mobileClose = document.querySelector('.main-product__mobile-tablet-title-review-price-container #fsa-hsa-close');
            window.Branch.fsa.modals[`${bannerType}`].desktopClose = document.querySelector('.main-product__title-review-price-container #fsa-hsa-close');
        } else if (bannerType == 'side-cart' ){
            window.Branch.fsa.modals[`${bannerType}`].mobileModal = document.querySelector('.fsa-hsa__side-cart #fsa-hsa-modal');
            window.Branch.fsa.modals[`${bannerType}`].desktopModal = document.querySelector('.fsa-hsa__side-cart #fsa-hsa-modal');
            window.Branch.fsa.modals[`${bannerType}`].mobileBtn = document.querySelector('.fsa-hsa__side-cart #fsa-hsa-cta');
            window.Branch.fsa.modals[`${bannerType}`].desktopBtn = document.querySelector('.fsa-hsa__side-cart #fsa-hsa-cta');
            window.Branch.fsa.modals[`${bannerType}`].mobileClose = document.querySelector('.fsa-hsa__side-cart #fsa-hsa-close');
            window.Branch.fsa.modals[`${bannerType}`].desktopClose = document.querySelector('.fsa-hsa__side-cart #fsa-hsa-close');     
        } else if(bannerType == 'bundle'){
            window.Branch.fsa.modals[`${bannerType}`].mobileModal = document.querySelector('.bundle-builder__mobile-tablet-title-review-price-container #fsa-hsa-modal');
            window.Branch.fsa.modals[`${bannerType}`].desktopModal = document.querySelector('.bundle-builder__title-review-price-container #fsa-hsa-modal');
            window.Branch.fsa.modals[`${bannerType}`].mobileBtn = document.querySelector('.bundle-builder__mobile-tablet-title-review-price-container #fsa-hsa-cta');
            window.Branch.fsa.modals[`${bannerType}`].desktopBtn = document.querySelector('.bundle-builder__title-review-price-container #fsa-hsa-cta');
            window.Branch.fsa.modals[`${bannerType}`].mobileClose = document.querySelector('.bundle-builder__mobile-tablet-title-review-price-container #fsa-hsa-close');
            window.Branch.fsa.modals[`${bannerType}`].desktopClose = document.querySelector('.bundle-builder__title-review-price-container #fsa-hsa-close');
        }
    }

    document.querySelector("body").appendChild(window.Branch.fsa.modals[`${bannerType}`].desktopModal);

    function addClickListeners(){
      window.Branch.fsa.modals[`${bannerType}`].mobileBtn.addEventListener("click", clickedFsaHsa);
      window.Branch.fsa.modals[`${bannerType}`].desktopBtn.addEventListener("click", clickedFsaHsa);
      window.Branch.fsa.modals[`${bannerType}`].mobileClose.addEventListener("click", closeFsaHsa);
      window.Branch.fsa.modals[`${bannerType}`].desktopClose.addEventListener("click", closeFsaHsa);
    }

    addClickListeners();

    function clickedFsaHsa(event){
      $(window.Branch.fsa.modals[`${bannerType}`].mobileModal).removeClass("fsa-modal-invisible");
      $(window.Branch.fsa.modals[`${bannerType}`].desktopModal).removeClass("fsa-modal-invisible");
      $(window.Branch.fsa.modals[`${bannerType}`].mobileModal).addClass("fsa-modal-visible");
      $(window.Branch.fsa.modals[`${bannerType}`].desktopModal).addClass("fsa-modal-visible");
    }

    function closeFsaHsa(){
      $(window.Branch.fsa.modals[`${bannerType}`].mobileModal).removeClass("fsa-modal-visible");
      $(window.Branch.fsa.modals[`${bannerType}`].mobileModal).addClass("fsa-modal-invisible");
      $(window.Branch.fsa.modals[`${bannerType}`].desktopModal).removeClass("fsa-modal-visible");
      $(window.Branch.fsa.modals[`${bannerType}`].desktopModal).addClass("fsa-modal-invisible");
    }

    window.addEventListener('click', (event) => {
      if (event.target === window.Branch.fsa.modals[`${bannerType}`].mobileModal || event.target === window.Branch.fsa.modals[`${bannerType}`].desktopModal ) {
        closeFsaHsa();
      }
    });
  }
})();


